import { Button, Popconfirm, Tooltip } from 'antd';
import { useNavigate } from "react-router-dom";
import { EyeFilled, EditFilled, DeleteFilled, FolderOpenFilled } from '@ant-design/icons';

const Columns = (showModal, handleDelete, filters, handleOpenChangeLog) => {
  return [
    {
      title: "Nombre del Área",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '30%',
    },
   
    {
      title: "Activos",
      dataIndex: ["delete_info", "assets"],
      key: "assets",
      render: (_, record) => record.delete_info?.assets ?? 0,
      sorter: (a, b) => (a.delete_info?.assets || 0) - (b.delete_info?.assets || 0),
      onHeaderCell: () => ({
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' }
      }),
      showSorterTooltip: false,
      width: '15%',
    },
    {
      title: "Controles",
      key: "controls",
      render: (_, record) => record.delete_info?.controls ?? 0,
      sorter: (a, b) => (a.delete_info?.controls || 0) - (b.delete_info?.controls || 0),
      onHeaderCell: () => ({
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold', className: 'custom-filter-icon' }
      }),
      showSorterTooltip: false,
      width: '15%',
    },
    {
      title: "GAPs",
      key: "gaps",
      render: (_, record) => record.delete_info?.gaps ?? 0,
      sorter: (a, b) => (a.delete_info?.gaps || 0) - (b.delete_info?.gaps || 0),
      onHeaderCell: () => ({
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold', className: 'custom-filter-icon' }
      }),
      showSorterTooltip: false,
      width: '15%',
    },
    {
      title: "Tareas",
      key: "tasks",
      render: (_, record) => record.delete_info?.tasks ?? 0,
      sorter: (a, b) => (a.delete_info?.tasks || 0) - (b.delete_info?.tasks || 0),
      onHeaderCell: () => ({
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold', className: 'custom-filter-icon' }
      }),
      showSorterTooltip: false,
      width: '15%',
    },
    {
      title: "Usuarios",
      key: "users",
      render: (_, record) => record.delete_info?.users ?? 0,
      sorter: (a, b) => (a.delete_info?.users || 0) - (b.delete_info?.users || 0),
      onHeaderCell: () => ({
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold', className: 'custom-filter-icon' }
      }),
      showSorterTooltip: false,
      width: '15%',
    },
    {
      title: "Acciones",
      key: "actions",
      render: (_, record) => {
        const canDelete = record.can_delete;

        return (
          <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
            <Button
              style={{ color: '#006939', fontSize: 18, padding: '0px 4px' }}
              type="link" 
              onClick={() => showModal(record)}>
              <Tooltip title="Editar Área"><EditFilled /></Tooltip>
            </Button>
            <Tooltip title="Ver Log">
              <FolderOpenFilled 
                style={{ fontSize: 20, cursor: 'pointer', color: '#006939' }}
                onClick={() => handleOpenChangeLog(record)}
              />
            </Tooltip>
            <Popconfirm 
              overlayClassName="custom-popconfirm"
              title="¿Seguro que deseas eliminar esta Área?" 
              onConfirm={() => handleDelete(record.id)}
              disabled={!canDelete}
            >
              <Button
                type="link"
                disabled={!canDelete}
                style={{ color: canDelete ? '#006939' : '#999999', fontSize: 18, padding: '0px 2px' }}
              >
                <Tooltip title="Eliminar Área"><DeleteFilled /></Tooltip>
              </Button>
            </Popconfirm>
          </div>
        )
      },
      onHeaderCell: () => ({ 
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold', textAlign: 'center' } 
      }),
      align: 'center',
      width: '10%',
    }    
  ];
};

export default Columns;